import axios from "axios";
import { API_URL } from "../constants";

export const fetch = (companyId, filtersValue, isUserGuest, isPrivate, onlyActivated) => {
  const queryParams = [
    isUserGuest !== undefined ? `isUserGuest=${isUserGuest}` : "",
    isPrivate !== undefined ? `isPrivate=${isPrivate}` : "",
    onlyActivated ? `onlyActivated=true` : "",
  ]
    .filter(Boolean)
    .join("&");

  const url = `${API_URL}/${companyId}/users/fetch${
    queryParams ? `?${queryParams}` : ""
  }`;
  return axios.post(url, { filtersValue }).then((response) => response.data);
};

export const fetchAllUsers = (companyId, filtersValue, source) => {
  const url = `${API_URL}/${companyId}/users/fetch-all-users`;
  return axios
    .post(url, { filtersValue, source })
    .then((response) => response.data);
};

// eslint-disable-next-line import/prefer-default-export
export const inviteToCompany = ({ userToInvite, companyId }) => {
  const url = `${API_URL}/${companyId}/users/inviteToCompany`;
  return axios.post(url, { userToInvite }).then((response) => response.data);
};

export const post = (data, companyId) => {
  const url = `${API_URL}/${companyId}/users/post`;
  return axios.post(url, data).then((response) => response.data);
};

export const fetchById = (userId, companyId) => {
  const url = `${API_URL}/${companyId}/users/${userId}`;
  return axios.get(url).then((response) => response.data);
};

export const getAuthCodeUrl = (companyId) => {
  const url = `${API_URL}/${companyId}/microsoft/get-auth-code-url`;
  return axios.get(url).then((response) => response.data);
};

export const disconnectMicrosoftSync = (companyId) => {
  const url = `${API_URL}/${companyId}/microsoft/delete-subscription`;
  return axios.get(url).then((response) => response.data);
};

export const fetchUserByPermission = (companyId, permission) => {
  let isUserGuestFilter = "";
  switch (permission) {
    case "Signature":
      isUserGuestFilter = false;
      break;

    default:
      isUserGuestFilter = undefined;
      break;
  }

  const queryParams = [
    isUserGuestFilter !== undefined ? `isUserGuest=${isUserGuestFilter}` : "",
  ]
    .filter(Boolean)
    .join("&");

  const url = `${API_URL}/${companyId}/users/fetch/${encodeURIComponent(permission)}${
    queryParams ? `?${queryParams}` : ""
  }`;
  return axios.get(url).then((response) => response.data);
};

export const assignCustomerToUser = async (companyId, formData) => {
  const url = `${API_URL}/${companyId}/users/customers/post`;
  return axios.post(url, formData).then((response) => response.data);
};

export const excludeCustomerToUser = async (companyId, formData) => {
  const url = `${API_URL}/${companyId}/users/customers/exclude/post`;
  return axios.post(url, formData).then((response) => response.data);
};

export const updateUserEmail = async (companyId, userId, email) => {
  const url = `${API_URL}/${companyId}/users/${userId}/email`;
  return axios.patch(url, { email }).then((response) => response.data);
};

export const mergeInCompany = (companyId, sourceUserId, targetUserId, dryRun = false, axiosConfig = {}) => {
  const url = `${API_URL}/${companyId}/users/merge`;
  return axios
    .post(url, { sourceUserId, targetUserId, dryRun }, axiosConfig)
    .then((response) => response.data);
};

export const fetchMergeHistoryList = (companyId, { page = 1, pageSize = 25 } = {}) => {
  const url = `${API_URL}/${companyId}/users/merge-history`;
  return axios
    .get(url, { params: { page, pageSize } })
    .then((response) => response.data);
};

export const fetchMergeHistoryDetail = (companyId, mergeBatchId, { page = 1, pageSize = 25 } = {}) => {
  const url = `${API_URL}/${companyId}/users/merge-history/${mergeBatchId}`;
  return axios
    .get(url, { params: { page, pageSize } })
    .then((response) => response.data);
};
